export { default as AddProposal } from "./add-proposal.component";
export { default as ProposalItem } from "./proposal-item.component";